// Central blog registry: add new posts here to make them appear everywhere
export const BLOG_POSTS = [
  {
    slug: "/the-real-difference-between-a-stable-msb-and-a-struggling-one",
    title: "The real difference between a stable MSB and a struggling one",
    date: "2026-08-08T12:00:00",
    image: "/assets/images/blogs/the-real-difference-between-a-stable-msb-and-a-struggling-one.png",
    excerpt: "The difference between a stable MSB and a struggling one is rarely about size or customer numbers. Learn how compliance, banking relationships, cash flow, and culture help build a resilient, successful UK money service business.",
  },
  {
    slug: "/how-economic-pressure-impacts-remittance-volumes-and-risk",
    title: "How economic pressure impacts remittance volumes and risk?",
    date: "2026-07-23T12:00:00",
    image: "/assets/images/blogs/how-economic-pressure-impacts-remittance-volumes-and-risk.png",
    excerpt: "Economic challenges such as inflation, unemployment, exchange rate volatility, and geopolitical uncertainty can significantly affect how much money customers send abroad. Learn how these pressures shape remittance volumes and what UK MSBs can do to strengthen risk management.",
  },
  {
    slug: "/what-banks-expect-from-msbs-during-annual-reviews",
    title: "What banks expect from MSBs during annual reviews?",
    date: "2026-03-14T12:00:00",
    image: "/assets/images/blogs/What-banks-expect-from-MSBs-during-annual-reviews.png",
    excerpt: "Money Service Businesses (MSBs) play a vital role in the financial system. They help individuals and businesses move money across borders, exchange currencies, and access financial services that traditional banks may not provide.",
  },
  {
    slug: "/transaction-monitoring-manual-vs-automated",
    title: "Transaction Monitoring: Manual vs Automated – What makes sense for smaller MSBs?",
    date: "2026-03-07T12:00:00",
    image: "/assets/images/blogs/transaction-monitoring-manual-vs-automated.png",
    excerpt: "Should smaller MSBs rely on manual monitoring, adopt automation, or use a combination of both? Explore what approach makes the most practical sense...",
  },
  {
    slug: "/are-traditional-msbs-losing-ground-to-digital-players",
    title: "Are traditional MSBs losing ground to digital players?",
    date: "2026-02-27",
    image:
      "/assets/images/blogs/are-traditional-msbs-losing-ground-to-digital-players.png",
    excerpt:
      "Money Service Businesses (MSBs), including money remittance providers, currency exchange operators, and cheque cashers, play a critical role in the financial ecosystem...",
  },
  {
    slug: "/key-compliance-dates-for-msbs-in-2026-what-to-watch-out-for",
    title: "Key Compliance Dates for MSBs in 2026 - what to watch out for?",
    date: "2026-02-20",
    image:
      "/assets/images/blogs/key-compliance-dates-for-msbs-in-2026-what-to-watch-out-for.png",
    excerpt:
      "Money Service Businesses (MSBs) which include money transmitters, currency exchange providers, and similar operations, operate in a highly regulated environment...",
  },
  {
    slug: "/effective-marketing-strategies-for-money-services-businesses",
    title: "Effective Marketing Strategies for Money Services Businesses",
    date: "2026-02-13",
    image:
      "/assets/images/blogs/effective-Marketing-Strategies-for-Money-Services-Businesses.png",
    excerpt:
      "Money Service Providers, commonly known as Money Services Businesses (MSBs), play a vital role in the financial ecosystem by offering essential services...",
  },
  {
    slug: "/lessons-learned-from-failed-money-service-businesses",
    title: "Lessons learned from failed money service businesses",
    date: "2026-02-06",
    image:
      "/assets/images/blogs/lessons-learned-from-failed-money-service-businesses.png",
    excerpt:
      "Money service businesses (MSBs) play a vital role in facilitating financial transactions such as currency exchange, money transfers, cheque cashing, and payment processing...",
  },
  {
    slug: "/when-love-becomes-a-threat-identifying-vulnerabilities-to-romance-fraud",
    title:
      "When Love Becomes a Threat: Identifying Vulnerabilities to Romance Fraud",
    date: "2025-12-04",
    image:
      "/assets/images/blogs/when-love-becomes-a-threat-identifying-vulnerabilities-to-romance-fraud.png",
    excerpt:
      "At the MSB Association, we're committed to promoting financial security and awareness...",
  },
  {
    slug: "/navigating-vat-taxes-and-financial-reporting-for-msbs",
    title: "Navigating VAT, Taxes, and Financial Reporting for MSBs",
    date: "2025-11-26",
    image:
      "/assets/images/blogs/navigating-vat-taxes-and-financial-reporting-for-msb.png",
    excerpt:
      "Running a Money Service Business in the UK, whether money remittance, currency exchange, or payment services...",
  },
  {
    slug: "/future-trends-in-remittances-msb-what-to-know",
    title: "Future Trends in Remittances: What MSBs need to know?",
    date: "2025-11-19",
    image:
      "/assets/images/blogs/future-trends-in-remittances-msb-what-to-know.jpg",
    excerpt:
      "The remittances industry is at a pivotal moment. Global flows continue to grow, driven by migration..",
  },
  {
    slug: "/the-cost-of-non-compliance-msb-risks-penalties",
    title:
      "The Cost of Non-Compliance: Penalties, Reputation, and Business Risks",
    date: "2025-11-12",
    image:
      "/assets/images/blogs/the-cost-of-non-compliance-msb-risks-penalties.png",
    excerpt:
      "Running a Money Service Businesses (MSBs) in the UK, whether a money transfer or currency exchange...",
  },
  {
    slug: "/how-msbs-can-enhance-customer-trust-through-transparency",
    title: "How MSBs Can Enhance Customer Trust Through Transparency?",
    date: "2025-11-05",
    image:
      "/assets/images/blogs/how-msbs-can-enhance-customer-trust-through-transparency.png",
    excerpt:
      "Money Services Businesses (MSBs) play a vital role in today’s financial world. From cheque cashing and money transfers to currency exchanges...",
  },
  {
    slug: "/how-to-onboard-and-train-staff-for-compliance-in-uk-msb",
    title: "How to Onboard & Train Staff for Compliance in a UK MSB?",
    date: "2025-10-29",
    image:
      "/assets/images/blogs/how-to-onboard-and-train-staff-for-compliance-in-uk-msb.png",
    excerpt:
      "In the United Kingdom, Money Services Businesses (MSBs) such as currency exchanges, money transmitters, and cheque cashers play...",
  },
  {
    slug: "/customer-data-protection-privacy-msbs",
    title: "Best Practices for Customer Data Protection & Privacy in MSBs",
    date: "2025-10-22",
    image: "/assets/images/blogs/customer-data-protection-privacy-msbs.png",
    excerpt:
      "MSBs in the UK handle sensitive customer information every day. Protecting that data is not just a regulatory...",
  },
  {
    slug: "/common-compliance-mistakes-msbs",
    title: "Common Compliance Mistakes MSBs Make & How to Avoid Them",
    date: "2025-10-15",
    image: "/assets/images/blogs/common-compliance-mistakes-msbs.png",
    excerpt:
      "Money Service Businesses (MSBs) such as money remittance services, currency exchanges, and cheque cashers operate in a highly regulated environment...",
  },
  {
    slug: "/kyc-cdd-msbs",
    title: "Understanding KYC & Customer Due Diligence for MSBs",
    date: "2025-10-08",
    image: "/assets/images/blogs/kyc-cdd-msbs.png",
    excerpt:
      "In today’s rapidly evolving financial landscape, Money Service Businesses (MSBs) operate under intense regulatory checks to combat money...",
  },
  {
    slug: "/guide-to-msb-regulation-uk-guide",
    title: "A Beginner’s Guide to MSB Regulation in the UK",
    date: "2025-09-25",
    image: "/assets/images/blogs/guide-to-msb-regulation-uk-guide.png",
    excerpt:
      "Learn the basics of MSB regulation in the UK, including compliance requirements, FCA registration, and how MSBs operate legally.",
  },
  {
    slug: "/future-of-cash-processing-msbs",
    title: "The Future of Cash - Is Cash Processing MSB a Dying Business?",
    date: "2025-09-16",
    image: "/assets/images/blogs/future-of-cash-processing-msbs-uk.png",
    excerpt:
      "Why cash isn’t disappearing in the UK. How MSBs modernise cash processing to stay compliant, inclusive, and essential.",
  },
];
